<template>
  <div class="type-menu flex">
    <div class="item"
    v-for="item in menu"
    :key="item.id"
    v-text="item.title"
    :class="{active:item.id==$route.params.tid}"
    @click="goto(item.id)"></div>
  </div>
</template>

<script>
export default {
  props: {
    menu: Array
  },
  computed: {
    name(){
      if(this.$route.name=="news" || this.$route.name=="newsdetail"){
        return "news"
      }else{
        return this.$route.name
      }

    }
  },
  mounted() {
    if (this.$route.name == 'research') {
      document.querySelector('.item:nth-child(2)').style.display='none'
    }
  },
  methods: {
    goto(id){
      this.$router.push({
         name: this.name,
         params: {
           tid: id
         }
       })

    }

  },
}
</script>

<style scoped>
.type-menu{
  justify-content: center;
}
.type-menu .item{
  width: 188px;
  border: 1px solid #e2e2e2;
  font-size: 14px;
  color: #000;
  text-align: center;
  cursor: pointer;
  transition: .3s;
  padding: 15px 0;
  position: relative;
  z-index: 1000;
  background: #ffffff;
}
.type-menu .item.active,.type-menu .item:hover{
  background-color: #005598;
  color: #fff;
}
@media (max-width: 1024px){
  .type-menu {
    flex-wrap: wrap;
    justify-content: unset;
    width: 90% !important;
    margin: auto;
  }
  .type-menu .item {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>


